/**
 * Normalize pathnames for comparisons (trailing slashes differ between dev Next and static export).
 */
export function stripTrailingSlashes(path: string | null | undefined): string {
  if (!path) {
    return '';
  }
  let p = path;
  while (p.length > 1 && p.endsWith('/')) {
    p = p.slice(0, -1);
  }
  return p;
}

export function isLoginPath(path: string | null | undefined): boolean {
  const p = stripTrailingSlashes(path);
  return p === '/login';
}
